import type { UUID } from "@@/shared/uuid";
import type {
    PaymentPubSubEventBase} from "../payment-pubsub-event-base";
import {
    createPaymentPubSubEventBase
} from "../payment-pubsub-event-base";
import type { PaymentPubSubEventTypeName } from "../payment-pubsub-event-type-name";

type RefundData = {
    refundUUID: UUID;
};

type TypeName = Extract<PaymentPubSubEventTypeName, "refund_fulfilled">;
type PaymentRefundFulfilledPubSubEvent = PaymentPubSubEventBase<
    TypeName,
    RefundData
>;

const createPaymentRefundFulfilledPubSubEvent = (
    eventData: PaymentRefundFulfilledPubSubEvent["data"]
): PaymentRefundFulfilledPubSubEvent => {
    return createPaymentPubSubEventBase<TypeName, RefundData>({
        triggeredBy: "SWISH",
        triggeredAt: eventData.createdAt,
        data: eventData,
        type: "payment:refund_fulfilled",
        namespace: "payment",
        tags: [],
    });
};

export type { PaymentRefundFulfilledPubSubEvent };
export { createPaymentRefundFulfilledPubSubEvent };
